import { faCheck, faCog, faPlus, faTrashAlt, faUndo, faUser, faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import InputMask from "react-input-mask";
import { withRouter } from '../_helpers/withRouter';
import { Link } from "react-router-dom";
import Select from 'react-select';
import DataTable from 'react-data-table-component';
import { formatCpf, formatCnpj } from '../../src/_utils/stringUtils'
import moment from 'moment';
import { faPlusCircle, faPen, faTrash } from '@fortawesome/free-solid-svg-icons'
import {
    Badge, Breadcrumb, BreadcrumbItem, Button, ButtonDropdown, Card, CardBody, CardHeader,
    Col, Container, DropdownItem, DropdownMenu, DropdownToggle, Form, FormGroup, Input, Label,
    Modal, ModalBody, ModalFooter, ModalHeader, Nav, NavItem, NavLink, TabPane, TabContent, Row, UncontrolledTooltip
} from 'reactstrap';
import Swal from 'sweetalert2';
import { authActions, cidadeAction, fazendaAction, fazendaCertificadoAction, fazendaIntegracaoAction, usuarioAction, animalAction, empresaAction, estadoAction, logAction } from '../_actions';
import NavBar from '../_components/navbar';
import { ModalLog } from '../log/';
import '././styles.css';
import './styles.css';
import { stringUtils } from '../_utils';

const FazendaEdit = (props) => {

    const toggle = () => setModal(!modal);
    const dispatch = useDispatch();
    const [term, setTerm] = useState('');
    const [editCertificado, setEditCertificado] = useState(false);
    const [idCertificado, setIdCertificado] = useState(0);

    const [editIntegracao, setEditIntegracao] = useState(false);
    const [idIntegracao, setIdIntegracao] = useState(0);

    const { match: { params } } = props;

    const [activeTab, setActiveTab] = useState('1');

    const toggleTab = (tab) => {
        if (activeTab !== tab) setActiveTab(tab);
    };

    const [modal, setModal] = useState(false);
    const [, forceUpdate] = React.useState(0);

    const [open, setOpen] = useState(false);
    const [openProducao, setOpenProducao] = useState(false);
    const [openPartos, setOpenPartos] = useState(false);
    const [openCcs, setOpenCcs] = useState(false);
    const [openCultura, setOpenCultura] = useState(false);
    const [openInseminacoes, setOpenInseminacoes] = useState(false);
    const [openSecagens, setOpenSecagens] = useState(false);
    const [openPesagens, setOpenPesagens] = useState(false);
    const [openAnimaisDescartados, setOpenAnimaisDescartados] = useState(false);
    const [openSaudeUbere, setOpenSaudeUbere] = useState(false);
    const [openCopiarFazenda, setOpenCopiarFazenda] = useState(false);
    const [openAcasalamentos, setOpenAcasalamentos] = useState(false);
    const [openRecuperarAnimal, setOpenRecuperarAnimal] = useState(false);
    const [openProtocolosSaude, setOpenProtocolosSaude] = useState(false);
    const [animalSelecionado, setAnimalSelecionado] = useState(0);
    const [fazendaSelecionada, setFazendaSelecionada] = useState('0');
    const [pessoaFisica, setPessoaFisica] = useState(false);
    const [pessoaFisicaCertificado, setPessoaFisicaCertificado] = useState(false);

    const [openCadastroCertificados, setOpenCadastroCertificados] = useState(false);
    const [openCadastroIntegracoes, setOpenCadastroIntegracoes] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    const [openModalConfirmationDeleteIntegracao, setOpenModalConfirmationDeleteIntegracao] = useState(false);

    const { fazendaCertificado } = props.fazendaCertificado;

    const { fazendaIntegracao } = props.fazendaIntegracao;

    const [id, setId] = useState(0);
    const [mesclar, setMesclar] = useState(false);

    const [isOpenDrop, setOpenDrop] = useState(false);
    const toggleDropDown = () => setOpenDrop(!isOpenDrop);

    const [isOpenDropRelatorios, setOpenDropRelatorios] = useState(false);
    const toggleDropDownRelatorios = () => setOpenDropRelatorios(!isOpenDropRelatorios);

    const [idUsuario, setIdUsuario] = useState(0);
    const [, setTextUsuario] = useState('');

    const [idUsuarioFinanceiro, setIdUsuarioFinanceiro] = useState(0);
    const [, setTextUsuarioFinanceiro] = useState('');

    useEffect(() => {

        dispatch(usuarioAction.getSelectUsuarios());
        dispatch(empresaAction.getEmpresasSelected());
        dispatch(estadoAction.getEstadosSelect());
        dispatch(fazendaAction.getFormasIngressoSelect());

        if (params.id) {
            dispatch(fazendaAction.getFazendaById(params.id, true));
            dispatch(fazendaCertificadoAction.getFazendaCertificadoByIdFazenda(params.id, true));
            dispatch(fazendaIntegracaoAction.getFazendaIntegracaoByIdFazenda(params.id, true));
            setId(params.id);
        } else {
            if (authActions.isGestor() === false) {
                props.history.push('/fazendas/');
            }
        }
    }, []);

    useEffect(() => {
        if (props.fazenda.id_estado && props.fazenda.id_estado != 0) {
            dispatch(cidadeAction.getCidadesSelect(props.fazenda.id_estado));
        }
    }, [props.fazenda.id_estado]);

    useEffect(() => {
        if (props.fazenda != null && props.fazenda != undefined) {

            if (props.fazenda.pessoa == 'F') {
                setPessoaFisica(true);
            }
            else {
                setPessoaFisica(false);
            }
        }

    }, [props.fazenda.pessoa])

    useEffect(() => {
        if (idCertificado && idCertificado != 0 && props.fazendaCertificado != null && props.fazendaCertificado != undefined && props.fazendaCertificado.chave) {

            if (props.fazendaCertificado.chave.replace(/\D/g, '').length == 14) {
                setPessoaFisicaCertificado(false);
            }
            else {
                setPessoaFisicaCertificado(true);
            }
        }

    }, [props.fazendaCertificado.chave, idCertificado])

    useEffect(() => {
        dispatch(animalAction.getAnimalByFazendaSelectExcluidos(params.id));
    }, [openRecuperarAnimal]);

    useEffect(() => {
        if (editCertificado && idCertificado && idCertificado != 0) {
            dispatch(fazendaCertificadoAction.getFazendaCertificadoById(idCertificado));
        } else {
            dispatch(fazendaCertificadoAction.clearChave());
        }
    }, [openCadastroCertificados, idCertificado, editCertificado]);

    useEffect(() => {
        if (editIntegracao && idIntegracao && idIntegracao != 0) {
            dispatch(fazendaIntegracaoAction.getFazendaIntegracaoById(idIntegracao));
        } else {
            dispatch(fazendaIntegracaoAction.clearCodigoIntegracao());
        }
    }, [openCadastroIntegracoes, idIntegracao, editIntegracao]);

    const handleClickOpenDeleteCertificado = (event, id) => {
        dispatch(fazendaCertificadoAction.deleteFazendaCertificadoById(id, params.id, true));
    };

    const handleClickOpenDeleteIntegracao = (event, id) => {
        dispatch(fazendaIntegracaoAction.deleteFazendaIntegracaoById(id, params.id, true));
    };

    const columns = [
        {
            name: 'Nome',
            selector: row => row.nome ? row.nome : '',
            sortable: true
        },
        {
            name: 'Pessoa',
            selector: row => row.chave
                ? (row.chave.replace(/\D/g, '').length == 14
                    ? 'JURÍDICA'
                    : 'FÍSICA')
                : '',
            sortable: true
        },
        {
            name: 'CPF/CNPJ',
            selector: row => row.chave
                ? (row.chave.replace(/\D/g, '').length == 14
                    ? formatCnpj(row.chave)
                    : formatCpf(row.chave))
                : '',
            sortable: true
        },
        {
            name: 'Data cadastro',
            selector: row => `${moment(row.data_cadastro).format(`DD/MM/yyyy`)}`,
            sortable: true
        },
        {
            name: 'Data validade',
            selector: row => `${moment(row.data_validade).format(`DD/MM/yyyy`)}`,
            sortable: true
        },
        {
            name: 'Ações',
            sortable: false,
            right: true,
            cell: row => <>
                <Button
                    color="primary" size="sm"
                    className={id == row.id ? editCertificado : ''}
                    component='a' onClick={() => handleClickOpenCadastroCertificados(row.id)}>
                    {id == row.id ? '' : <FontAwesomeIcon icon={faPen} />}
                </Button>
                <Button color="danger" size="sm"
                    className="ml-1"
                    onClick={(event) => handleClickOpenDeleteCertificado(event, row.id)}>
                    <FontAwesomeIcon icon={faTrash} />
                </Button>
            </>,
        },
    ]

    const columnsIntegracao = [
        {
            name: 'Código',
            selector: row => row.codigo_integracao
                ? row.codigo_integracao : '',
            sortable: true
        },
        {
            name: 'Data cadastro',
            selector: row => `${moment(row.data_cadastro).format(`DD/MM/yyyy`)}`,
            sortable: true
        },
        {
            name: 'Ações',
            sortable: false,
            right: true,
            cell: row => <>
                <Button
                    color="primary" size="sm"
                    className={id == row.id ? editIntegracao : ''}
                    component='a' onClick={() => handleClickOpenCadastroIntegracoes(row.id)}>
                    {id == row.id ? '' : <FontAwesomeIcon icon={faPen} />}
                </Button>
                <Button color="danger" size="sm"
                    className="ml-1"
                    onClick={(event) => handleClickOpenDeleteIntegracao(event, row.id)}>
                    <FontAwesomeIcon icon={faTrash} />
                </Button>
            </>,
        },
    ]

    const handleChangeTerm = prop => event => {
        setTerm(event.target.value);
    };

    useEffect(() => {
        dispatch(fazendaAction.getFazenda(params.id));
    }, [openCopiarFazenda]);

    const handleChangeRadio = prop => event => {

        props.fazenda.codigo = ''

        if (prop == 'fisica') {
            setPessoaFisica(true);
        }
        else {
            setPessoaFisica(false);
        }
    };

    const handleChangeRadioCertificado = prop => event => {

        props.fazendaCertificado.chave = ''

        if (prop == 'fisica') {
            setPessoaFisicaCertificado(true);
        }
        else {
            setPessoaFisicaCertificado(false);
        }
    };

    const handleAddOnList = e => {

        if (props.fazenda.listaUsuarios.filter(ts => ts.id_usuario === parseInt(idUsuario)).length > 0) {
            Swal.fire({
                icon: 'warning',
                title: 'Erro ao adicionar',
                showCloseButton: true,
                showConfirmButton: true,
                html: '<div style="font-size: 14px; text-align: center">Usuário já existe!</div>'
            });
        }
        else {
            if (idUsuario !== '' && idUsuario !== '0') {
                props.fazenda.listaUsuarios.push({ 'id_usuario': idUsuario, 'data_cadastro': '1900-01-01T00:00:00' });
                forceUpdate(n => !n);
                setIdUsuario(0);
                setTextUsuario('');
            } else {
                Swal.fire({
                    icon: 'warning',
                    title: 'Erro ao salvar',
                    showCloseButton: true,
                    showConfirmButton: true,
                    html: '<div style="font-size: 14px; text-align: center">Informe ao menos um usuário!</div>'
                });
            }
        }
    }

    const handleRemoveOnList = id => {
        props.fazenda.listaUsuarios = props.fazenda.listaUsuarios.filter(ts => ts.id_usuario !== parseInt(id));
        forceUpdate(n => !n);
    };

    const handleAddOnListFinanceiro = e => {

        if (props.fazenda.usuarios_financeiro?.filter(ts => ts.id_usuario === parseInt(idUsuarioFinanceiro)).length > 0) {
            Swal.fire({
                icon: 'warning',
                title: 'Erro ao adicionar',
                showCloseButton: true,
                showConfirmButton: true,
                html: '<div style="font-size: 14px; text-align: center">Usuário já existe!</div>'
            });
        }
        else {
            if (idUsuarioFinanceiro !== '' && idUsuarioFinanceiro !== '0') {
                props.fazenda.usuarios_financeiro.push({ 'id_usuario': idUsuarioFinanceiro, 'data_cadastro': '1900-01-01T00:00:00' });
                forceUpdate(n => !n);
                setIdUsuarioFinanceiro(0);
                setTextUsuarioFinanceiro('');
            } else {
                Swal.fire({
                    icon: 'warning',
                    title: 'Erro ao salvar',
                    showCloseButton: true,
                    showConfirmButton: true,
                    html: '<div style="font-size: 14px; text-align: center">Informe ao menos um usuário!</div>'
                });
            }
        }
    }

    const handleRemoveOnListFinanceiro = id => {
        props.fazenda.usuarios_financeiro = props.fazenda.usuarios_financeiro.filter(ts => ts.id_usuario !== parseInt(id));
        forceUpdate(n => !n);
    };

    function getUsuarioNome(id) {
        var usuario = props.usuario.usuario.filter(u => u.Value == id);
        if (usuario[0] != null) {
            return usuario[0].Text;
        }
        else {
            return '';
        }
    }

    const renderOptionsEstados = () => {
        return props.estado.estado.map((p, i) => {
            return (
                { value: p.Value, label: p.Text, key: i }
            );
        });
    };

    const renderOptionsCidades = () => {
        return props.cidade.cidade.map((p, i) => {
            return (
                { value: p.Value, label: p.Text, key: i }
            );
        });
    };

    const renderOptionsAnimalRecuperar = () => {
        if (props.animal && props.animal.animal && Array.isArray(props.animal.animal)) {
            return props.animal.animal.map((p, i) => {
                return (
                    { value: p.Value, label: p.Text, key: i }
                );
            });
        }
        return [];
    };

    const renderOptionsFazendas = () => {
        return props.fazenda.fazenda.map((p, i) => {
            return (
                { value: p.id, label: p.nome }
            );
        });
    };

    const renderOptionsTipoIntegracao = () => {
        var tipoData = [
            { value: '', name: 'SELECIONE...' },
            { value: 'O', name: 'Ordemax' },
            { value: 'F', name: 'Fazenda' }
        ];
        return tipoData.map((p, i) => {
            return (
                { value: p.value, label: p.name }
            );
        });
    };

    const renderOptionsFormasIngresso = () => {
        if (props.fazenda && props.fazenda.formasIngresso && Array.isArray(props.fazenda.formasIngresso)) {
            return props.fazenda.formasIngresso.map((p, i) => {
                return (
                    { value: p.Value, label: p.Text, key: i }
                );
            });
        }
        return [];
    };

    const handleSelectChange = prop => event => {
        var event2 = {
            type: 'select',
            target: {
                value: event.value
            }
        };

        if (prop === 'id_fazenda') {
            setFazendaSelecionada(event.value);
        }

        dispatch(animalAction.onChangeProps(prop, event2));
        dispatch(fazendaAction.onChangeProps(prop, event2));
        setAnimalSelecionado(event.value);
    };

    const handleSelectChangeState = prop => event => {
        setIdUsuario(event.value);
        setTextUsuario(event.label);
    };

    const handleSelectChangeStateFinanceiro = prop => event => {
        setIdUsuarioFinanceiro(event.value);
        setTextUsuarioFinanceiro(event.label);
    };

    const handleChange = prop => event => {
        const { dispatch } = props;
        dispatch(fazendaAction.onChangeProps(prop, event));
    };

    const handleChangeCertificado = prop => event => {
        // Despacha a ação com o valor atualizado
        dispatch(fazendaCertificadoAction.onChangeProps(prop, event));
    };

    const handleChangeIntegracao = prop => event => {
        dispatch(fazendaIntegracaoAction.onChangeProps(prop, event));
    };

    const handleSelectChangeIntegracao = prop => event => {
        var event2 = {
            type: 'select',
            target: {
                value: event.value
            }
        };

        if (prop === 'id_fazenda') {
            setFazendaSelecionada(event.value);
        }

        dispatch(fazendaIntegracaoAction.onChangeProps(prop, event2));
    };

    const handleValidation = event => {

        var valid = true;
        var errors = '';
        var cpf_cnpj = props.fazenda.codigo ? props.fazenda.codigo.replace(/\D/g, '') : ''

        if (props.fazenda.nome === null || props.fazenda.nome === '') {
            valid = false;
            errors += '<li style="float:left;">Informe um nome válido!</li><br>';
        }
        if (props.fazenda.dias_secagem === null || props.fazenda.dias_secagem === '') {
            valid = false;
            errors += '<li style="float:left;">Informe a quantidade de dias para a Secagem!</li><br>';
        }
        if (props.fazenda.dias_secagem > 70) {
            valid = false;
            errors += '<li style="float:left;">Dias para secagem não pode ser maior que 70!</li><br>';
        }
        if (props.fazenda.dias_parto === null || props.fazenda.dias_parto === '') {
            valid = false;
            errors += '<li style="float:left;">Informe a quantidade de dias para o Parto!</li><br>';
        }
        if (props.fazenda.dias_pre_parto === null || props.fazenda.dias_pre_parto === '') {
            valid = false;
            errors += '<li style="float:left;">Informe a quantidade de dias para o Pré Parto!</li><br>';
        }
        if (props.fazenda.pev === null || props.fazenda.pev === '') {
            valid = false;
            errors += '<li style="float:left;">Informe o valor do PEV!</li><br>';
        }
        if (props.fazenda.limite_peso_cio === null || props.fazenda.limite_peso_cio === '') {
            valid = false;
            errors += '<li style="float:left;">Informe um limite de peso para o CIO!</li><br>';
        }
        if (props.fazenda.limite_idade_cio === null || props.fazenda.limite_idade_cio === '') {
            valid = false;
            errors += '<li style="float:left;">Informe um limite de idade para o CIO!</li><br>';
        }

        if (cpf_cnpj != '' && cpf_cnpj.length <= 11 && pessoaFisica == true) {
            if (stringUtils.validaCPF(cpf_cnpj) == false) {
                valid = false;
                errors += '<li style="float:left;">Informe um CPF válido!</li><br>';
            }
        } else {
            if (cpf_cnpj != '' && stringUtils.validaCNPJ(cpf_cnpj) == false) {
                valid = false;
                errors += '<li style="float:left;">Informe um CNPJ válido!</li><br>';
            }
        }

        if (pessoaFisica == true && (cpf_cnpj == null || cpf_cnpj == '')) {
            valid = false;
            errors += '<li style="float:left;">Informe um CPF!</li><br>';
        }

        if (pessoaFisica == false && (cpf_cnpj == null || cpf_cnpj == '')) {
            valid = false;
            errors += '<li style="float:left;">Informe um CNPJ!</li><br>';
        }

        if (props.fazenda.dias_bst === null || props.fazenda.dias_bst === '') {
            valid = false;
            errors += '<li style="float:left;">Informe a quantidade de dias para a aplicação de BST!</li><br>';
        }

        if ((typeof props.fazenda.listaUsuarios === 'undefined' || props.fazenda.listaUsuarios.length <= 0) && props.fazenda.usuarios_financeiro <= 0) {
            valid = false;
            errors += '<li style="float:left;">Informe ao menos um usuário!</li><br>';
        }

        if (props.fazenda.id_estado === null || props.fazenda.id_estado == 0) {
            valid = false;
            errors += '<li style="float:left;">Informe um estado!</li><br>';
        }

        if (props.fazenda.id_cidade === null || props.fazenda.id_cidade == 0) {
            valid = false;
            errors += '<li style="float:left;">Informe uma cidade!</li><br>';
        }

        if (!valid) {
            Swal.fire({
                icon: 'warning',
                title: 'Erros de validação',
                showCloseButton: true,
                showConfirmButton: true,
                html: '<div style="font-size: 14px; text-align: left"><ul>' + errors + '</ul></div>'
            });
        }
        return valid;
    };

    const handleValidationCertificado = event => {

        var valid = true;
        var errors = '';

        if (props.fazendaCertificado.chave.replace(/\D/g, '') === null || props.fazendaCertificado.chave.replace(/\D/g, '') === '') {
            valid = false;
            errors += '<li style="float:left;">Informe um CPF ou CNPJ para o certificado!</li><br>';
        }

        if (!valid) {
            Swal.fire({
                icon: 'warning',
                title: 'Erros de validação',
                showCloseButton: true,
                showConfirmButton: true,
                html: '<div style="font-size: 14px; text-align: left"><ul>' + errors + '</ul></div>'
            });
        }
        return valid;
    };

    const handleValidationIntegracao = event => {

        var valid = true;
        var errors = '';

        if (props.fazendaIntegracao.codigo_integracao.replace(/\D/g, '') === null || props.fazendaIntegracao.codigo_integracao.replace(/\D/g, '') === '') {
            valid = false;
            errors += '<li style="float:left;">Informe um código para a integração!</li><br>';
        }

        if (!valid) {
            Swal.fire({
                icon: 'warning',
                title: 'Erros de validação',
                showCloseButton: true,
                showConfirmButton: true,
                html: '<div style="font-size: 14px; text-align: left"><ul>' + errors + '</ul></div>'
            });
        }
        return valid;
    };

    const setFile = (event) => {
        props.fazenda.arquivo = event.target.files[0];
        forceUpdate();
    }

    const renderOptionsEmpresas = () => {
        return props.empresa.empresa.map((p, i) => {
            return (
                {
                    value: p.Value, label: p.Text,
                }
            );
        });
    };

    const handleImport = () => {

        const { dispatch } = props;

        if (props.fazenda.arquivo === null || props.fazenda.arquivo === '') {
            alert('Informe um Arquivo válido!');
        } else {

            var formData = new FormData();
            formData.append('fazenda', params.id);
            formData.append('file', props.fazenda.arquivo);

            if (params.id) {
                dispatch(fazendaAction.importFazenda(formData, true));
            }
        }
    };

    const handleImportSecagens = () => {

        const { dispatch } = props;

        if (props.fazenda.arquivo === null || props.fazenda.arquivo === '') {
            Swal.fire({
                icon: 'warning',
                title: 'Erro de validação',
                showCloseButton: true,
                showConfirmButton: true,
                html: '<div style="font-size: 14px; text-align: left">Informe um arquivo válido!</div>'
            });
        } else {

            var formData = new FormData();
            formData.append('fazenda', params.id);
            formData.append('file', props.fazenda.arquivo);

            if (params.id) {
                dispatch(fazendaAction.importSecagensFazenda(formData, true));
            }

        }
    };

    const handleImportPesagens = () => {

        const { dispatch } = props;

        if (props.fazenda.arquivo === null || props.fazenda.arquivo === '') {
            Swal.fire({
                icon: 'warning',
                title: 'Erro de validação',
                showCloseButton: true,
                showConfirmButton: true,
                html: '<div style="font-size: 14px; text-align: left">Informe um arquivo válido!</div>'
            });
        } else {

            var formData = new FormData();
            formData.append('fazenda', params.id);
            formData.append('file', props.fazenda.arquivo);

            if (params.id) {
                dispatch(fazendaAction.importPesagensFazenda(formData, true));
            }

        }
    };

    const handleImportAnimaisDescartados = () => {

        const { dispatch } = props;

        if (props.fazenda.arquivo === null || props.fazenda.arquivo === '') {
            Swal.fire({
                icon: 'warning',
                title: 'Erro de validação',
                showCloseButton: true,
                showConfirmButton: true,
                html: '<div style="font-size: 14px; text-align: left">Informe um arquivo válido!</div>'
            });
        } else {

            var formData = new FormData();
            formData.append('fazenda', params.id);
            formData.append('file', props.fazenda.arquivo);

            if (params.id) {
                dispatch(fazendaAction.importAnimaisDescartadosFazenda(formData, true));
            }

        }
    };

    const handleImportSaudeUberes = () => {

        const { dispatch } = props;

        if (props.fazenda.arquivo === null || props.fazenda.arquivo === '') {
            Swal.fire({
                icon: 'warning',
                title: 'Erro de validação',
                showCloseButton: true,
                showConfirmButton: true,
                html: '<div style="font-size: 14px; text-align: left">Informe um arquivo válido!</div>'
            });
        } else {

            var formData = new FormData();
            formData.append('fazenda', params.id);
            formData.append('file', props.fazenda.arquivo);

            if (params.id) {
                dispatch(fazendaAction.importSaudeUberesFazenda(formData, true));
            }

        }
    };

    const handleImportProducao = () => {

        const { dispatch } = props;

        if (props.fazenda.arquivo === null || props.fazenda.arquivo === '') {
            Swal.fire({
                icon: 'warning',
                title: 'Erro de validação',
                showCloseButton: true,
                showConfirmButton: true,
                html: '<div style="font-size: 14px; text-align: left">Informe um arquivo válido!</div>'
            });
        } else {

            var formData = new FormData();
            formData.append('fazenda', params.id);
            formData.append('file', props.fazenda.arquivo);

            if (params.id) {
                dispatch(fazendaAction.importProducaoFazenda(formData, true));
            }

        }
    };

    const renderOptionsUsuario = () => {
        return props.usuario.usuario.map((p, i) => {
            //console.log("USUARIOS", props.usuario.usuario)
            return (
                { value: p.Value, label: p.Text }
            );
        });
    };

    const handleImportAcasalamentos = () => {

        const { dispatch } = props;

        if (props.fazenda.arquivo === null || props.fazenda.arquivo === '') {
            alert('Informe um Arquivo válido!');
        } else {

            var formData = new FormData();
            formData.append('fazenda', params.id);
            formData.append('file', props.fazenda.arquivo);

            if (params.id) {
                dispatch(fazendaAction.importAcasalamentosFazenda(formData, true));
            }

        }
    };

    const handleImportCcs = () => {

        const { dispatch } = props;

        if (props.fazenda.arquivo === null || props.fazenda.arquivo === '') {
            alert('Informe um Arquivo válido!');
        } else {

            var formData = new FormData();
            formData.append('fazenda', params.id);
            formData.append('file', props.fazenda.arquivo);

            if (params.id) {
                dispatch(fazendaAction.importCcsFazenda(formData, true));
            }
        }
    };

    const handleImportProtocolosSaude = () => {

        const { dispatch } = props;

        if (props.fazenda.arquivo === null || props.fazenda.arquivo === '') {
            Swal.fire({
                icon: 'warning',
                title: 'Erro de validação',
                showCloseButton: true,
                showConfirmButton: true,
                html: '<div style="font-size: 14px; text-align: left">Informe um arquivo válido!</div>'
            });
        } else {

            var formData = new FormData();
            formData.append('id_fazenda', params.id);
            formData.append('file', props.fazenda.arquivo);

            if (params.id) {
                dispatch(fazendaAction.importSaudeAnimalFazenda(formData, true));
            }

        }
    };

    const handleImportCultura = () => {

        const { dispatch } = props;

        if (props.fazenda.arquivo === null || props.fazenda.arquivo === '') {
            alert('Informe um Arquivo válido!');
        } else {

            var formData = new FormData();
            formData.append('fazenda', params.id);
            formData.append('file', props.fazenda.arquivo);

            if (params.id) {
                dispatch(fazendaAction.importCulturaFazenda(formData, true));
            }
        }
    };

    const handleImportPartos = () => {

        const { dispatch } = props;

        if (props.fazenda.arquivo === null || props.fazenda.arquivo === '') {
            alert('Informe um Arquivo válido!');
        } else {

            var formData = new FormData();
            formData.append('fazenda', params.id);
            formData.append('file', props.fazenda.arquivo);

            if (params.id) {
                dispatch(fazendaAction.importPartosFazenda(formData, true));
            }
        }
    };

    const handleImportInseminacoes = () => {

        const { dispatch } = props;

        if (props.fazenda.arquivo === null || props.fazenda.arquivo === '') {
            alert('Informe um Arquivo válido!');
        } else {

            var formData = new FormData();
            formData.append('fazenda', params.id);
            formData.append('file', props.fazenda.arquivo);
            formData.append('mesclar', mesclar);

            if (params.id) {
                dispatch(fazendaAction.importInseminacoesFazenda(formData, true));
            }
        }
    };

    const handleSubmit = event => {

        event.preventDefault();

        if (handleValidation()) {

            let payload = {
                id: params.id,
                nome: props.fazenda.nome,
                nome_proprietario: props.fazenda.nome_proprietario,
                pessoa: (pessoaFisica == true ? 'F' : 'J'),
                codigo: (props.fazenda.codigo ? props.fazenda.codigo.replace(/\D/g, '') : null),
                data_inicio_cobranca: props.fazenda.data_inicio_cobranca,
                data_inicio_cobranca_financeiro: props.fazenda.data_inicio_cobranca_financeiro,
                data_treinamento: props.fazenda.data_treinamento,
                data_treinamento_financeiro: props.fazenda.data_treinamento_financeiro,
                data_importacao: props.fazenda.data_importacao,
                dias_secagem: props.fazenda.dias_secagem,
                dias_parto: props.fazenda.dias_parto,
                dias_pre_parto_novilha: props.fazenda.dias_pre_parto_novilha,
                dias_pre_parto: props.fazenda.dias_pre_parto,
                data: props.fazenda.data,
                limite_peso_cio: props.fazenda.limite_peso_cio,
                limite_idade_cio: props.fazenda.limite_idade_cio,
                dias_bst: props.fazenda.dias_bst,
                pev: props.fazenda.pev,
                listaUsuarios: props.fazenda.listaUsuarios,
                usuarios_financeiro: props.fazenda.usuarios_financeiro,
                gera_cobranca: props.fazenda.gera_cobranca,
                gera_cobranca_financeiro: props.fazenda.gera_cobranca_financeiro,
                modulo_financeiro: props.fazenda.modulo_financeiro,
                modulo_zootecnico: props.fazenda.modulo_zootecnico,
                id_empresa: props.fazenda.id_empresa,
                endereco: props.fazenda.endereco,
                id_cidade: props.fazenda.id_cidade,
                id_estado: props.fazenda.id_estado,
                id_forma_ingresso: props.fazenda.id_forma_ingresso ? parseInt(props.fazenda.id_forma_ingresso) : null
            };

            if (params.id) {
                dispatch(fazendaAction.editFazendaInfo(params.id, payload, true));

            } else {
                dispatch(fazendaAction.createFazenda(payload, true));
            }
        }

    };

    const handleSubmitCertificado = event => {

        event.preventDefault();

        if (handleValidationCertificado()) {

            let payload = {
                id: idCertificado,
                id_fazenda: params.id,
                chave: props.fazendaCertificado.chave.replace(/\D/g, ''),
                nome: props.fazendaCertificado.nome,
                data_validade: props.fazendaCertificado.data_validade,
                senha: props.fazendaCertificado.senha,
                caminho_certificado: props.fazendaCertificado.caminho_certificado
            };

            if (idCertificado && idCertificado != 0) {
                dispatch(fazendaCertificadoAction.editFazendaCertificadoInfo(idCertificado, payload, true));
                setOpenCadastroCertificados(false)
            } else {
                dispatch(fazendaCertificadoAction.createFazendaCertificado(payload, true));
                setOpenCadastroCertificados(false)
            }
        }

    };

    const handleSubmitIntegracao = event => {

        event.preventDefault();

        if (handleValidationIntegracao()) {

            let payload = {
                id: idIntegracao,
                id_fazenda: params.id,
                codigo_integracao: props.fazendaIntegracao.codigo_integracao ? props.fazendaIntegracao.codigo_integracao.replace(/\D/g, '') : '',
                tipo: props.fazendaIntegracao.tipo
            };

            console.log('payload', payload);

            if (idIntegracao && idIntegracao != 0) {
                dispatch(fazendaIntegracaoAction.editFazendaIntegracaoInfo(idIntegracao, payload, true));
                setOpenCadastroIntegracoes(false)
            } else {
                dispatch(fazendaIntegracaoAction.createFazendaIntegracao(payload, true));
                setOpenCadastroIntegracoes(false)
            }
        }

    };

    const handleClickHistory = event => {

        event.preventDefault();
        const { dispatch } = props;

        if (params.id) {
            dispatch(logAction.getLog('Fazenda', params.id));
            toggle();
        }

    };


    const handleRecuperarAnimal = event => {

        event.preventDefault();

        if (params.id) {
            dispatch(animalAction.reativarAnimal(animalSelecionado));
            handleCloseRecuperarAnimal();
        }
    }

    const handleCopiarFazenda = event => {

        const { dispatch } = props;

        var formData = new FormData();
        formData.append('fazenda', params.id);
        formData.append('fazenda_copia', fazendaSelecionada);

        if (params.id) {
            dispatch(fazendaAction.copyFazenda(formData, true));
        }
    }


    const handleClickOpen = () => {
        setOpen(true)
    };

    const handleClose = () => {
        setOpen(false)
    };

    const handleCloseModalConfirmationDeleteIntegracao = () => {
        setOpenModalConfirmationDeleteIntegracao(false)
    };

    const handleClickOpenProducao = () => {
        setOpenProducao(true)
    };

    const handleClickOpenCopiarFazenda = () => {
        setOpenCopiarFazenda(true)
    };

    const handleClickOpenAnimaisDescartados = () => {
        setOpenAnimaisDescartados(true)
    };

    const handleClickOpenSecagens = () => {
        setOpenSecagens(true)
    };

    const handleClickOpenPesagens = () => {
        setOpenPesagens(true)
    };

    const handleClickOpenCadastroCertificados = (id) => {
        setShowPassword(false);
        if (id && id != 0) {
            setEditCertificado(true);
            setIdCertificado(id);
            setOpenCadastroCertificados(true)
        } else {
            setEditCertificado(false);
            setIdCertificado(0);
            setOpenCadastroCertificados(true)
        }
    };

    const handleClickOpenCadastroIntegracoes = (id) => {
        if (id && id != 0) {
            setEditIntegracao(true);
            setIdIntegracao(id);
            setOpenCadastroIntegracoes(true)
        } else {
            setEditIntegracao(false);
            setIdIntegracao(0);
            setOpenCadastroIntegracoes(true)
        }
    };

    const handleCloseCadastroCertificados = () => {
        setShowPassword(false);
        setOpenCadastroCertificados(false)
    };

    const handleCloseCadastroIntegracoes = () => {
        setOpenCadastroIntegracoes(false)
    };

    const handleClickOpenSaudeUbere = () => {
        setOpenSaudeUbere(true)
    };

    const handleClickOpenPartos = () => {
        setOpenPartos(true)
    };

    const handleClickOpenInseminacoes = () => {
        setOpenInseminacoes(true)
    };

    const handleClickOpenCcs = () => {
        setOpenCcs(true)
    };

    const handleClickOpenCultura = () => {
        setOpenCultura(true)
    };

    const handleClickOpenAcasalamentos = () => {
        setOpenAcasalamentos(true)
    };

    const handleClickOpenProtocolosSaude = () => {
        setOpenProtocolosSaude(true)
    };

    const handleClickOpenRecuperarAnimal = () => {
        setOpenRecuperarAnimal(true)
    };

    const handleCloseAnimaisDescartados = () => {
        setOpenAnimaisDescartados(false)
    };

    const handleCloseProducao = () => {
        setOpenProducao(false)
    };

    const handleCloseCopiarFazenda = () => {
        setOpenCopiarFazenda(false)
    };

    const handleCloseCcs = () => {
        setOpenCcs(false)
    };

    const handleCloseCultura = () => {
        setOpenCultura(false)
    };

    const handleClosePesagens = () => {
        setOpenPesagens(false)
    };

    const handleCloseSecagens = () => {
        setOpenSecagens(false)
    };

    const handleCloseSaudeUbere = () => {
        setOpenSaudeUbere(false)
    };

    const handleClosePartos = () => {
        setOpenPartos(false)
    };

    const handleCloseInseminacoes = () => {
        setOpenInseminacoes(false)
    };

    const handleCloseAcasalamentos = () => {
        setOpenAcasalamentos(false)
    };

    const handleCloseProtocolosSaude = () => {
        setOpenProtocolosSaude(false)
    };

    const handleCloseRecuperarAnimal = () => {
        setOpenRecuperarAnimal(false)
    };

    const { log } = props.log;

    return (
        <div>
            <NavBar {...props} />
            <Container>
                <Card>
                    <CardHeader>
                        <Row>
                            <Col md={12}>
                                <Breadcrumb>
                                    <BreadcrumbItem><a href="/fazendas">Lista de Fazendas</a></BreadcrumbItem>
                                    <BreadcrumbItem active>Fazenda {props.fazenda.id}</BreadcrumbItem>
                                    <BreadcrumbItem className="pb-0 pt-0 m-0 btn btn-muted">
                                        <a href="#" id="tagHistorico" onClick={(event) => handleClickHistory(event)}>Histórico</a>
                                        <UncontrolledTooltip placement="bottom" target="tagHistorico">
                                            Exibe o histórico de alterações do registro
                                        </UncontrolledTooltip>
                                    </BreadcrumbItem>
                                </Breadcrumb>
                            </Col>
                        </Row>
                    </CardHeader>
                    <Nav tabs>
                        <NavItem>
                            <NavLink
                                className={activeTab === '1' ? 'active' : ''}
                                onClick={() => { toggleTab('1'); }}
                            >
                                Dados de cadastro da fazenda
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink
                                className={activeTab === '2' ? 'active' : ''}
                                onClick={() => { toggleTab('2'); }}
                            >
                                Certificados
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink
                                className={activeTab === '3' ? 'active' : ''}
                                onClick={() => { toggleTab('3'); }}
                            >
                                Integrações
                            </NavLink>
                        </NavItem>
                    </Nav>
                    <CardBody>
                        <TabContent activeTab={activeTab}>
                            <TabPane tabId="1">
                                <Form onSubmit={(event) => handleSubmit(event)}>
                                    {/* --- DADOS DE IDENTIFICAÇÃO --- */}
                                    <Row className="mt-3">
                                        <Col md={3} lg={3}>
                                            <FormGroup className="form-group-custom">
                                                <Label for="nome">Nome Fazenda*</Label>
                                                <Input
                                                    id="nome"
                                                    label="Nome"
                                                    className="form-control"
                                                    value={props.fazenda.nome}
                                                    onChange={handleChange('nome')} />
                                            </FormGroup>
                                        </Col>
                                        <Col md={3} lg={3}>
                                            <FormGroup className="form-group-custom">
                                                <Label for="nome_proprietario">Nome Proprietário</Label>
                                                <Input
                                                    id="nome_proprietario"
                                                    label="Nome_Proprietario"
                                                    className="form-control"
                                                    value={props.fazenda.nome_proprietario}
                                                    onChange={handleChange('nome_proprietario')} />
                                            </FormGroup>
                                        </Col>
                                        <Col md={6} lg={6}>
                                            <Row>
                                                <Col md={5}>
                                                    <FormGroup className="form-group-custom">
                                                        <Label for="pessoa">Pessoa *</Label>
                                                        <div className="radio-group-container">
                                                            <label className="radio-option">
                                                                <Input
                                                                    type="radio"
                                                                    name="pessoa"
                                                                    checked={pessoaFisica}
                                                                    onChange={handleChangeRadio('fisica')}
                                                                />
                                                                <span>Física</span>
                                                            </label>
                                                            <label className="radio-option">
                                                                <Input
                                                                    type="radio"
                                                                    name="pessoa"
                                                                    checked={!pessoaFisica}
                                                                    onChange={handleChangeRadio('juridica')}
                                                                />
                                                                <span>Jurídica</span>
                                                            </label>
                                                        </div>
                                                    </FormGroup>
                                                </Col>
                                                <Col md={7}>
                                                    <FormGroup className="form-group-custom">
                                                        <Label for="codigo">{pessoaFisica == true ? 'CPF *' : 'CNPJ *'}</Label>
                                                        <Input
                                                            id="codigo"
                                                            label="codigo"
                                                            className="form-control"
                                                            value={props.fazenda.codigo || ''}
                                                            onChange={handleChange('codigo')}
                                                            mask={pessoaFisica == true ? '999.999.999-99' : '99.999.999/9999-99'}
                                                            maskChar=" "
                                                            tag={InputMask}
                                                        />
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>

                                    {/* --- LOCALIZAÇÃO E EMPRESA --- */}
                                    <Row className="mt-3">
                                        <Col md={3} lg={3}>
                                            <FormGroup className="form-group-custom">
                                                <Label for="id_endereco">Endereço</Label>
                                                <Input
                                                    id="id_endereco"
                                                    label="Endereco"
                                                    className="form-control"
                                                    value={props.fazenda.endereco}
                                                    onChange={handleChange('endereco')} />
                                            </FormGroup>
                                        </Col>
                                        <Col md={3} lg={3}>
                                            <FormGroup className="form-group-custom">
                                                <Label for="id_estado">Estado *</Label>
                                                <Select
                                                    classNamePrefix="select"
                                                    placeholder="Selecione..."
                                                    className="basic-single"
                                                    value={renderOptionsEstados().filter(function (option) {
                                                        return option.value == props.fazenda.id_estado
                                                    })}
                                                    onChange={handleSelectChange('id_estado')}
                                                    isSearchable
                                                    id="id_estado"
                                                    name="id_estado"
                                                    options={renderOptionsEstados()}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md={3} lg={3}>
                                            <FormGroup className="form-group-custom">
                                                <Label for="id_cidade">Cidade *</Label>
                                                <Select
                                                    classNamePrefix="select"
                                                    placeholder="Selecione..."
                                                    className="basic-single"
                                                    value={renderOptionsCidades().filter(function (option) {
                                                        return option.value == props.fazenda.id_cidade
                                                    })}
                                                    onChange={handleSelectChange('id_cidade')}
                                                    isSearchable
                                                    id="id_cidade"
                                                    name="id_cidade"
                                                    options={renderOptionsCidades()}
                                                />
                                            </FormGroup>
                                        </Col>
                                        {authActions.isGestor() ?
                                            <Col md={3} lg={3}>
                                                <FormGroup className="form-group-custom">
                                                    <Label for="id_empresa">Empresa</Label>
                                                    <Select
                                                        classNamePrefix="select"
                                                        placeholder="Selecione..."
                                                        className="basic-single"
                                                        value={renderOptionsEmpresas().filter(function (option) {
                                                            return option.value == props.fazenda.id_empresa
                                                        })}
                                                        onChange={handleSelectChange('id_empresa')}
                                                        isSearchable
                                                        id="id_empresa"
                                                        name="id_empresa"
                                                        options={renderOptionsEmpresas()}
                                                    />
                                                </FormGroup>
                                            </Col>
                                            : null}
                                    </Row>

                                    {/* --- CONFIGURAÇÕES ZOOTÉCNICAS --- */}
                                    <Row className="mt-3">
                                        <Col md={3} lg={3}>
                                            <FormGroup className="form-group-custom">
                                                <Label for="dias_secagem">Dias para Secagem *</Label>
                                                <Input
                                                    id="dias_secagem"
                                                    label="Dias Secagem"
                                                    className="form-control"
                                                    value={props.fazenda.dias_secagem}
                                                    onChange={handleChange('dias_secagem')} />
                                            </FormGroup>
                                        </Col>
                                        <Col md={3} lg={3}>
                                            <FormGroup className="form-group-custom">
                                                <Label for="dias_parto">Dias para Parto *</Label>
                                                <Input
                                                    id="dias_parto"
                                                    label="Dias Parto"
                                                    className="form-control"
                                                    value={props.fazenda.dias_parto}
                                                    onChange={handleChange('dias_parto')} />
                                            </FormGroup>
                                        </Col>
                                        <Col md={3} lg={3}>
                                            <FormGroup className="form-group-custom">
                                                <Label for="dias_pre_parto_novilha">Dias para Pré-Parto Novilhas*</Label>
                                                <Input
                                                    id="dias_pre_parto_novilha"
                                                    label="Dias Pré-Parto-Novilha"
                                                    className="form-control"
                                                    value={props.fazenda.dias_pre_parto_novilha}
                                                    onChange={handleChange('dias_pre_parto_novilha')} />
                                            </FormGroup>
                                        </Col>
                                        <Col md={3} lg={3}>
                                            <FormGroup className="form-group-custom">
                                                <Label for="dias_pre_parto">Dias para Pré-Parto Vacas*</Label>
                                                <Input
                                                    id="dias_pre_parto"
                                                    label="Dias Pré-Parto"
                                                    className="form-control"
                                                    value={props.fazenda.dias_pre_parto}
                                                    onChange={handleChange('dias_pre_parto')} />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={3} lg={3}>
                                            <FormGroup className="form-group-custom">
                                                <Label for="pev">PEV *</Label>
                                                <Input
                                                    id="pev"
                                                    label="PEV"
                                                    className="form-control"
                                                    value={props.fazenda.pev}
                                                    onChange={handleChange('pev')} />
                                            </FormGroup>
                                        </Col>
                                        <Col md={3} lg={3}>
                                            <FormGroup className="form-group-custom">
                                                <Label for="limite_peso_cio">Limite Peso Cio (Kg) *</Label>
                                                <Input
                                                    id="limite_peso_cio"
                                                    label="Limite Peso Cio"
                                                    className="form-control"
                                                    value={props.fazenda.limite_peso_cio}
                                                    onChange={handleChange('limite_peso_cio')} />
                                            </FormGroup>
                                        </Col>
                                        <Col md={3} lg={3}>
                                            <FormGroup className="form-group-custom">
                                                <Label for="limite_idade_cio">Limite Idade Cio (meses) *</Label>
                                                <Input
                                                    id="limite_idade_cio"
                                                    label="Limite Idade Cio"
                                                    className="form-control"
                                                    value={props.fazenda.limite_idade_cio}
                                                    onChange={handleChange('limite_idade_cio')} />
                                            </FormGroup>
                                        </Col>
                                        <Col md={3} lg={3}>
                                            <FormGroup className="form-group-custom">
                                                <Label for="dias_bst">Int. aplicação BST (dias) *</Label>
                                                <Input
                                                    id="dias_bst"
                                                    label="Intervalo aplicação BST"
                                                    className="form-control"
                                                    value={props.fazenda.dias_bst}
                                                    onChange={handleChange('dias_bst')} />
                                            </FormGroup>
                                        </Col>
                                    </Row>

                                    {/* --- CONTROLE DE FATURAMENTO E DATAS --- */}
                                    {authActions.isGestor() && (
                                        <>
                                            <Row className="mt-3 mb-3">
                                                <Col md={3}>
                                                    <FormGroup className="form-group-custom">
                                                        <Label for="id_forma_ingresso">Forma de Ingresso</Label>
                                                        <Select
                                                            classNamePrefix="select"
                                                            placeholder="Selecione..."
                                                            className="basic-single"
                                                            value={renderOptionsFormasIngresso().filter(function (option) {
                                                                return option.value == props.fazenda.id_forma_ingresso
                                                            })}
                                                            onChange={handleSelectChange('id_forma_ingresso')}
                                                            isSearchable
                                                            id="id_forma_ingresso"
                                                            name="id_forma_ingresso"
                                                            options={renderOptionsFormasIngresso()}
                                                        />
                                                    </FormGroup>
                                                </Col>
                                                <Col md={3}>
                                                    <FormGroup className="form-group-custom">
                                                        <Label for="data_importacao">Data Importação</Label>
                                                        <Input
                                                            id="data_importacao"
                                                            className="form-control"
                                                            type="date"
                                                            value={props.fazenda.data_importacao ? new Date(props.fazenda.data_importacao).toISOString().split('T')[0] : ''}
                                                            onChange={handleChange('data_importacao')}
                                                        />
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row className="mb-3">
                                                <Col md={3}>
                                                    <FormGroup check className="mt-4">
                                                        <Label check className="d-flex align-items-center">
                                                            <Input
                                                                type="checkbox"
                                                                checked={props.fazenda.modulo_zootecnico || false}
                                                                onChange={handleChange('modulo_zootecnico')}
                                                            />{' '}
                                                            Módulo Zootécnico
                                                        </Label>
                                                    </FormGroup>
                                                </Col>
                                                <Col md={3}>
                                                    <FormGroup check className="mt-4">
                                                        <Label check className="d-flex align-items-center">
                                                            <Input
                                                                type="checkbox"
                                                                checked={props.fazenda.gera_cobranca || false}
                                                                onChange={handleChange('gera_cobranca')}
                                                            />{' '}
                                                            Gerar Cobrança Zootécnico
                                                        </Label>
                                                    </FormGroup>
                                                </Col>
                                                <Col md={3}>
                                                    <FormGroup check className="mt-4">
                                                        <Label check className="d-flex align-items-center">
                                                            <Input
                                                                type="checkbox"
                                                                checked={props.fazenda.modulo_financeiro || false}
                                                                onChange={handleChange('modulo_financeiro')}
                                                            />{' '}
                                                            Módulo Financeiro
                                                        </Label>
                                                    </FormGroup>
                                                </Col>
                                                <Col md={3}>
                                                    <FormGroup check className="mt-4">
                                                        <Label check className="d-flex align-items-center">
                                                            <Input
                                                                type="checkbox"
                                                                checked={props.fazenda.gera_cobranca_financeiro || false}
                                                                onChange={handleChange('gera_cobranca_financeiro')}
                                                            />{' '}
                                                            Gerar Cobrança Financeiro
                                                        </Label>
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row className="mb-3">
                                                <Col md={3}>
                                                    <FormGroup className="form-group-custom">
                                                        <Label for="data_treinamento">Data Treinamento Zootécnico</Label>
                                                        <Input
                                                            id="data_treinamento"
                                                            className="form-control"
                                                            type="date"
                                                            value={props.fazenda.data_treinamento ? new Date(props.fazenda.data_treinamento).toISOString().split('T')[0] : ''}
                                                            onChange={handleChange('data_treinamento')}
                                                        />
                                                    </FormGroup>
                                                </Col>
                                                {props.fazenda.gera_cobranca && (
                                                    <Col md={3}>
                                                        <FormGroup className="form-group-custom">
                                                            <Label for="data_inicio_cobranca">Data início cobrança Zootécnico*</Label>
                                                            <Input
                                                                id="data_inicio_cobranca"
                                                                className="form-control"
                                                                type="date"
                                                                value={props.fazenda.data_inicio_cobranca ? new Date(props.fazenda.data_inicio_cobranca).toISOString().split('T')[0] : ''}
                                                                onChange={handleChange('data_inicio_cobranca')}
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                )}
                                                {props.fazenda.modulo_financeiro && (
                                                     <Col md={3}>
                                                        <FormGroup className="form-group-custom">
                                                            <Label for="data_treinamento_financeiro">Data Treinamento Financeiro</Label>
                                                            <Input
                                                                id="data_treinamento_financeiro"
                                                                className="form-control"
                                                                type="date"
                                                                value={props.fazenda.data_treinamento_financeiro ? new Date(props.fazenda.data_treinamento_financeiro).toISOString().split('T')[0] : ''}
                                                                onChange={handleChange('data_treinamento_financeiro')}
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                )}
                                                {props.fazenda.modulo_financeiro && props.fazenda.gera_cobranca_financeiro && (
                                                     <Col md={3}>
                                                        <FormGroup className="form-group-custom">
                                                            <Label for="data_inicio_cobranca_financeiro">Data início cobrança Financeiro*</Label>
                                                            <Input
                                                                id="data_inicio_cobranca_financeiro"
                                                                className="form-control"
                                                                type="date"
                                                                value={props.fazenda.data_inicio_cobranca_financeiro ? new Date(props.fazenda.data_inicio_cobranca_financeiro).toISOString().split('T')[0] : ''}
                                                                onChange={handleChange('data_inicio_cobranca_financeiro')}
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                )}
                                            </Row>
                                        </>
                                    )}

                                    <Row className="mb-4">
                                        {authActions.isGestor() ? (
                                            <Col md={12}>
                                                <div className="section-header">
                                                    <FontAwesomeIcon icon={faUser} className="fa-icon" />
                                                    <h5 className="m-0">Relação de usuários - App Zootécnico</h5>
                                                </div>
                                                <div className="form-section shadow-sm border p-3">
                                                    <Row className="align-items-end">
                                                        <Col md={6} lg={5}>
                                                            <FormGroup className="form-group-custom mb-0">
                                                                <Label for="id_usuario">Selecionar Usuário</Label>
                                                                <Select
                                                                    classNamePrefix="select"
                                                                    className="basic-single"
                                                                    value={renderOptionsUsuario().find(opt => opt.value === (idUsuario || '0'))}
                                                                    onChange={handleSelectChangeState('id_usuario')}
                                                                    isSearchable
                                                                    placeholder="Pesquisar usuário..."
                                                                    options={renderOptionsUsuario()}
                                                                />
                                                            </FormGroup>
                                                        </Col>
                                                        <Col md={2}>
                                                            <Button
                                                                color="primary"
                                                                onClick={handleAddOnList}
                                                                className="mb-0"
                                                            >
                                                                <FontAwesomeIcon icon={faPlus} className="mr-2" /> Adicionar
                                                            </Button>
                                                        </Col>
                                                    </Row>

                                                    <div className="mt-4">
                                                        <div className="d-flex flex-wrap">
                                                            {props.fazenda?.listaUsuarios?.map((n, index) => (
                                                                n.id_usuario && (
                                                                    <Badge
                                                                        pill
                                                                        color="light"
                                                                        className="mr-2 mb-2 p-2 px-3 border border-primary d-flex align-items-center"
                                                                        key={`user-zoo-${index}`}
                                                                    >
                                                                        <Link
                                                                            style={{ textDecoration: 'none', color: 'var(--primary-color)' }}
                                                                            to={{ pathname: `/usuario/${n.id_usuario}` }}
                                                                            target="_blank"
                                                                        >
                                                                            {getUsuarioNome(n.id_usuario)}
                                                                        </Link>
                                                                        <FontAwesomeIcon
                                                                            icon={faTrashAlt}
                                                                            className="ml-2 text-danger cursor-pointer"
                                                                            onClick={() => handleRemoveOnList(n.id_usuario)}
                                                                        />
                                                                    </Badge>
                                                                )
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>
                                            </Col>
                                        ) : null}
                                    </Row>

                                    <Row className="mb-4">
                                        {authActions.isGestor() ? (
                                            <Col md={12}>
                                                <div className="section-header">
                                                    <FontAwesomeIcon icon={faUser} className="fa-icon" />
                                                    <h5 className="m-0">Relação de usuários - App Financeiro</h5>
                                                </div>
                                                <div className="form-section shadow-sm border p-3">
                                                    <Row className="align-items-end">
                                                        <Col md={6} lg={5}>
                                                            <FormGroup className="form-group-custom mb-0">
                                                                <Label for="id_usuario_fin">Selecionar Usuário</Label>
                                                                <Select
                                                                    classNamePrefix="select"
                                                                    className="basic-single"
                                                                    value={renderOptionsUsuario().find(opt => opt.value === (idUsuarioFinanceiro || '0'))}
                                                                    onChange={handleSelectChangeStateFinanceiro('id_usuario')}
                                                                    isSearchable
                                                                    placeholder="Pesquisar usuário..."
                                                                    options={renderOptionsUsuario()}
                                                                />
                                                            </FormGroup>
                                                        </Col>
                                                        <Col md={2}>
                                                            <Button
                                                                color="primary"
                                                                onClick={handleAddOnListFinanceiro}
                                                                className="mb-0"
                                                            >
                                                                <FontAwesomeIcon icon={faPlus} className="mr-2" /> Adicionar
                                                            </Button>
                                                        </Col>
                                                    </Row>

                                                    <div className="mt-4">
                                                        <div className="d-flex flex-wrap">
                                                            {props.fazenda?.usuarios_financeiro?.map((n, index) => (
                                                                n.id_usuario && (
                                                                    <Badge
                                                                        pill
                                                                        color="light"
                                                                        className="mr-2 mb-2 p-2 px-3 border border-primary d-flex align-items-center"
                                                                        key={`user-fin-${index}`}
                                                                    >
                                                                        <Link
                                                                            style={{ textDecoration: 'none', color: 'var(--primary-color)' }}
                                                                            to={{ pathname: `/usuario/${n.id_usuario}` }}
                                                                            target="_blank"
                                                                        >
                                                                            {getUsuarioNome(n.id_usuario)}
                                                                        </Link>
                                                                        <FontAwesomeIcon
                                                                            icon={faTrashAlt}
                                                                            className="ml-2 text-danger cursor-pointer"
                                                                            onClick={() => handleRemoveOnListFinanceiro(n.id_usuario)}
                                                                        />
                                                                    </Badge>
                                                                )
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>
                                            </Col>
                                        ) : null}
                                    </Row>
                                    <br />
                                    <Row>
                                        <Col className="left" md="3" lg="3">
                                            <span>* Campos obrigatórios</span>
                                        </Col>
                                    </Row>
                                    <Row>

                                        <Col className="d-flex  justify-content-end" lg="12">
                                            <Button className="mr-1" variant="contained" color="secondary" component='a' href="/fazendas">Voltar <FontAwesomeIcon icon={faUndo} /></Button>
                                            <Button className="mr-1" variant="contained" color="primary" type="submit" style={{ backgroundColor: 'var(--primary-color)', border: 'none' }}>Salvar <FontAwesomeIcon icon={faCheck} /></Button>
                                            {/*{authActions.isGestor() &&*/}
                                            {/*    <ButtonDropdown className="mr-1" isOpen={isOpenDropRelatorios} toggle={toggleDropDownRelatorios}>*/}
                                            {/*        <DropdownToggle caret color="danger">*/}
                                            {/*            Relatórios <FontAwesomeIcon icon={faFilePdf} />*/}
                                            {/*        </DropdownToggle>*/}
                                            {/*        <DropdownMenu>*/}
                                            {/*            <DropdownItem variant="contained" className="mr-1" color="warning" onClick={handleGeraRelatorioAnimais}>Animais</DropdownItem>*/}
                                            {/*        </DropdownMenu>*/}
                                            {/*    </ButtonDropdown>*/}
                                            {/*}*/}
                                            {id > 0 &&
                                                <ButtonDropdown className="mr-1" isOpen={isOpenDrop} toggle={toggleDropDown}>
                                                    <DropdownToggle caret color="success">
                                                        Importações
                                                    </DropdownToggle>
                                                    <DropdownMenu>
                                                        <DropdownItem variant="contained" className="mr-1" color="warning" onClick={handleClickOpenAcasalamentos}>Acasalamentos</DropdownItem>
                                                        <DropdownItem variant="contained" className="mr-1" color="warning" onClick={handleClickOpenAnimaisDescartados}>Animais descartados</DropdownItem>
                                                        <DropdownItem variant="contained" className="mr-1" color="warning" onClick={handleClickOpenCcs}>CCS</DropdownItem>
                                                        <DropdownItem variant="contained" className="mr-1" color="warning" onClick={handleClickOpenCultura}>Cultura</DropdownItem>
                                                        {authActions.isGestor() &&
                                                            <>
                                                                <DropdownItem variant="contained" className="mr-1" color="success" onClick={handleClickOpen}>Fazenda</DropdownItem>
                                                                <DropdownItem variant="contained" className="mr-1" color="warning" onClick={handleClickOpenInseminacoes}>Inseminações</DropdownItem>
                                                                <DropdownItem variant="contained" className="mr-1" color="warning" onClick={handleClickOpenPartos}>Partos</DropdownItem>
                                                            </>
                                                        }
                                                        <DropdownItem variant="contained" className="mr-1" color="warning" onClick={handleClickOpenPesagens}>Pesagens</DropdownItem>
                                                        <DropdownItem variant="contained" className="mr-1" color="warning" onClick={handleClickOpenProtocolosSaude}>Saúde dos Animais</DropdownItem>
                                                        <DropdownItem variant="contained" className="mr-1" color="warning" onClick={handleClickOpenProducao}>Produções</DropdownItem>
                                                        {authActions.isGestor() &&
                                                            <>
                                                                <DropdownItem variant="contained" className="mr-1" color="warning" onClick={handleClickOpenSecagens}>Secagens</DropdownItem>
                                                            </>
                                                        }
                                                    </DropdownMenu>
                                                </ButtonDropdown>
                                            }
                                            {authActions.isGestor() &&
                                                <>
                                                    <Button variant="contained" className="mr-1" color="info" onClick={handleClickOpenRecuperarAnimal}>Recuperar animal <FontAwesomeIcon icon={faCog} /></Button>
                                                </>
                                            }
                                        </Col>
                                    </Row>
                                    <Modal isOpen={open} onClose={handleClose} aria-labelledby="form-dialog-title">
                                        <ModalHeader id="form-dialog-title">Importação de Fazenda via Arquivo Excel</ModalHeader>
                                        <ModalBody>
                                            <p>
                                                <span>Arquivo em formato Excel (.xls, .xlsx, ou .csv) contendo as informações da Fazenda.</span>
                                                <span>Arquivo de modelo: <a href="./modelo_importacao.xlsm" target="_blank" download>Modelo de Importação</a></span>
                                            </p>
                                            <Row>
                                                <Col>
                                                    <FormGroup>
                                                        <Label className="left" for="nome">Excel</Label>
                                                        <Input
                                                            id="arquivo"
                                                            label="Arquivo"
                                                            onChange={e => setFile(e)}
                                                            type="file"
                                                        />
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                        </ModalBody>
                                        <ModalFooter>
                                            <Button onClick={handleClose} color="secondary">Cancelar</Button>
                                            <Button onClick={(event) => handleImport(event)} color="primary">Importar Fazenda</Button>
                                        </ModalFooter>
                                    </Modal>

                                    <Modal isOpen={openSecagens} onClose={handleCloseSecagens} aria-labelledby="form-dialog-title">
                                        <ModalHeader id="form-dialog-title">Importação de Secagens via Arquivo Excel</ModalHeader>
                                        <ModalBody>
                                            <p>
                                                <span>Arquivo em formato Excel (.xls, .xlsx, ou .csv) contendo as informações das Secagens. </span>
                                                <span>Arquivo de modelo: <a href="./modelo_importacao_secagem.xlsx" target="_blank" download>Modelo de Importação de secagens</a></span>
                                            </p>
                                            <Row>
                                                <Col>
                                                    <FormGroup>
                                                        <Label className="left" for="nome">Excel</Label>
                                                        <Input
                                                            id="arquivo"
                                                            label="Arquivo"
                                                            onChange={e => setFile(e)}
                                                            type="file"
                                                        />
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                        </ModalBody>
                                        <ModalFooter>
                                            <Button onClick={handleCloseSecagens} color="secondary">Cancelar</Button>
                                            <Button onClick={(event) => handleImportSecagens(event)} color="primary">Importar Secagens</Button>
                                        </ModalFooter>
                                    </Modal>

                                    <Modal isOpen={openPesagens} onClose={handleClosePesagens} aria-labelledby="form-dialog-title">
                                        <ModalHeader id="form-dialog-title">Importação de Pesagens via Arquivo Excel</ModalHeader>
                                        <ModalBody>
                                            <p>
                                                <span>Arquivo em formato Excel (.xls, .xlsx, ou .csv) contendo as informações das Pesagens. </span>
                                                <span>Arquivo de modelo: <a href="./modelo_importacao_pesagens.xlsx" target="_blank" download>Modelo de Importação de pesagens</a></span>
                                            </p>
                                            <Row>
                                                <Col>
                                                    <FormGroup>
                                                        <Label className="left" for="nome">Excel</Label>
                                                        <Input
                                                            id="arquivo"
                                                            label="Arquivo"
                                                            onChange={e => setFile(e)}
                                                            type="file"
                                                        />
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                        </ModalBody>
                                        <ModalFooter>
                                            <Button onClick={handleClosePesagens} color="secondary">Cancelar</Button>
                                            <Button onClick={(event) => handleImportPesagens(event)} color="primary">Importar Pesagens</Button>
                                        </ModalFooter>
                                    </Modal>

                                    <Modal isOpen={openAnimaisDescartados} onClose={handleCloseAnimaisDescartados} aria-labelledby="form-dialog-title">
                                        <ModalHeader id="form-dialog-title">Importação de Animais Descartados via Arquivo Excel</ModalHeader>
                                        <ModalBody>
                                            <p>
                                                <span>Arquivo em formato Excel (.xls, .xlsx, ou .csv) contendo as informações dos animais descartados. </span>
                                                <span>Arquivo de modelo: <a href="./modelo_importacao_animais_descartados.xlsx" target="_blank" download>Modelo de Importação de Animais Descartados</a></span>
                                            </p>
                                            <Row>
                                                <Col>
                                                    <FormGroup>
                                                        <Label className="left" for="nome">Excel</Label>
                                                        <Input
                                                            id="arquivo"
                                                            label="Arquivo"
                                                            onChange={e => setFile(e)}
                                                            type="file"
                                                        />
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                        </ModalBody>
                                        <ModalFooter>
                                            <Button onClick={handleCloseAnimaisDescartados} color="secondary">Cancelar</Button>
                                            <Button onClick={(event) => handleImportAnimaisDescartados(event)} color="primary">Importar Animais Descartados</Button>
                                        </ModalFooter>
                                    </Modal>

                                    <Modal isOpen={openSaudeUbere} onClose={handleCloseSaudeUbere} aria-labelledby="form-dialog-title">
                                        <ModalHeader id="form-dialog-title">Importação de Saúde de Úberes via Arquivo Excel</ModalHeader>
                                        <ModalBody>
                                            <p>
                                                <span>Arquivo em formato Excel (.xls, .xlsx, ou .csv) contendo as informações das Saúde de Úbere. </span>
                                                <span>Arquivo de modelo: <a href="./modelo_importacao_saude_ubere.xlsx" target="_blank" download>Modelo de Importação Saúde de Úberes</a></span>
                                            </p>
                                            <Row>
                                                <Col>
                                                    <FormGroup>
                                                        <Label className="left" for="nome">Excel</Label>
                                                        <Input
                                                            id="arquivo"
                                                            label="Arquivo"
                                                            onChange={e => setFile(e)}
                                                            type="file"
                                                        />
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                        </ModalBody>
                                        <ModalFooter>
                                            <Button onClick={handleCloseSaudeUbere} color="secondary">Cancelar</Button>
                                            <Button onClick={(event) => handleImportSaudeUberes(event)} color="primary">Importar Saúde de Úbere</Button>
                                        </ModalFooter>
                                    </Modal>

                                    <Modal isOpen={openProtocolosSaude} onClose={handleCloseProtocolosSaude} aria-labelledby="form-dialog-title">
                                        <ModalHeader id="form-dialog-title">Importação de Saúde dos Animais via Arquivo Excel</ModalHeader>
                                        <ModalBody>
                                            <p>
                                                <span>Arquivo em formato Excel (.xls, .xlsx, ou .csv) contendo as informações da Saúde dos Animais. </span>
                                                <span>Arquivo de modelo: <a href="./modelo_importacao_saude_animais.xlsx" target="_blank" download>Modelo de Importação de Saúde dos Animais</a></span>
                                            </p>
                                            <Row>
                                                <Col>
                                                    <FormGroup>
                                                        <Label className="left" for="nome">Excel</Label>
                                                        <Input
                                                            id="arquivo"
                                                            label="Arquivo"
                                                            onChange={e => setFile(e)}
                                                            type="file"
                                                        />
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                        </ModalBody>
                                        <ModalFooter>
                                            <Button onClick={handleCloseProtocolosSaude} color="secondary">Cancelar</Button>
                                            <Button onClick={(event) => handleImportProtocolosSaude(event)} color="primary">Importar Protocolos</Button>
                                        </ModalFooter>
                                    </Modal>

                                    <Modal isOpen={openCcs} onClose={handleCloseCcs} aria-labelledby="form-dialog-title">
                                        <ModalHeader id="form-dialog-title">Importação de CCS da Fazenda via Arquivo Excel</ModalHeader>
                                        <ModalBody>
                                            <p>
                                                <strong>Instruções para a importação da CCS</strong>
                                            </p>

                                            <p>
                                                Para que os dados importados sejam considerados corretamente nos gráficos e relatórios, é necessário observar as seguintes regras:
                                            </p>

                                            <ul>
                                                <li>
                                                    O lançamento da <strong className="text-yellow-highlight">produção de leite </strong>
                                                    deve ser realizado antes do lançamento da <strong className="text-yellow-highlight">CCS individual</strong>.
                                                </li>

                                                <li>
                                                    A diferença entre a data da CCS individual e a data da produção de leite não pode ser superior a
                                                    <strong className="text-yellow-highlight"> 21 dias</strong>.
                                                </li>

                                                <li>
                                                    Como o tanque não possui data específica de lançamento, será considerado o
                                                    <strong className="text-yellow-highlight"> mês e o ano</strong>
                                                    para identificar o período ao qual a CCS individual pertence.
                                                </li>

                                                <li>
                                                    Caso existam múltiplos lançamentos de CCS no mesmo mês, será considerado
                                                    <strong className="text-yellow-highlight"> o último lançamento realizado</strong>.
                                                </li>
                                            </ul>

                                            <p>
                                                O arquivo deve estar no formato Excel (<strong>.xls, .xlsx ou .csv</strong>) e seguir o modelo padrão disponibilizado abaixo:
                                                <br />
                                                <a href="./modelo_importacao_ccs.xlsx" target="_blank" download>
                                                    Modelo de Importação de CCS
                                                </a>
                                            </p>

                                            <Row>
                                                <Col>
                                                    <FormGroup>
                                                        <Label className="left" for="arquivo">Arquivo</Label>
                                                        <Input
                                                            id="arquivo"
                                                            label="Arquivo"
                                                            onChange={e => setFile(e)}
                                                            type="file"
                                                        />
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                        </ModalBody>
                                        <ModalFooter>
                                            <Button onClick={handleCloseCcs} color="secondary">Cancelar</Button>
                                            <Button onClick={(event) => handleImportCcs(event)} color="primary">Importar CCS</Button>
                                        </ModalFooter>
                                    </Modal>

                                    <Modal isOpen={openCultura} onClose={handleCloseCultura} aria-labelledby="form-dialog-title">
                                        <ModalHeader id="form-dialog-title">Importação de Cultura da Fazenda via Arquivo Excel</ModalHeader>
                                        <ModalBody>
                                            <p>
                                                <span>Arquivo em formato Excel (.xls, .xlsx, ou .csv) contendo as informações da Cultura.</span><br />
                                                <span>Arquivo de modelo: <a href="./modelo_importacao_cultura.xlsx" target="_blank" download>Modelo de Importação de Cultura</a></span>
                                            </p>
                                            <Row>
                                                <Col>
                                                    <FormGroup>
                                                        <Label className="left" for="arquivo">Excel</Label>
                                                        <Input
                                                            id="arquivo"
                                                            label="Arquivo"
                                                            onChange={e => setFile(e)}
                                                            type="file"
                                                        />
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                        </ModalBody>
                                        <ModalFooter>
                                            <Button onClick={handleCloseCultura} color="secondary">Cancelar</Button>
                                            <Button onClick={(event) => handleImportCultura(event)} color="primary">Importar Cultura</Button>
                                        </ModalFooter>
                                    </Modal>

                                    <Modal isOpen={openAcasalamentos} onClose={handleCloseAcasalamentos} aria-labelledby="form-dialog-title">
                                        <ModalHeader id="form-dialog-title">Importação de Acasalamentos da Fazenda via Arquivo Excel</ModalHeader>
                                        <ModalBody>
                                            <p>
                                                <span>Arquivo em formato Excel (.xls, .xlsx, ou .csv) contendo as informações dos Acasalamentos.</span><br />
                                                <span>Arquivo de modelo: <a href="./modelo_importacao_acasalamentos.xlsx" target="_blank" download>Modelo de Importação de Acasalamentos</a></span>
                                            </p>
                                            <Row>
                                                <Col>
                                                    <FormGroup>
                                                        <Label className="left" for="arquivo">Excel</Label>
                                                        <Input
                                                            id="arquivo"
                                                            label="Arquivo"
                                                            onChange={e => setFile(e)}
                                                            type="file"
                                                        />
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                        </ModalBody>
                                        <ModalFooter>
                                            <Button onClick={handleCloseAcasalamentos} color="secondary">Cancelar</Button>
                                            <Button onClick={(event) => handleImportAcasalamentos(event)} color="primary">Importar Acasalamentos</Button>
                                        </ModalFooter>
                                    </Modal>

                                    <Modal isOpen={openProducao} onClose={handleCloseProducao} aria-labelledby="form-dialog-title">
                                        <ModalHeader id="form-dialog-title">Importação de Produções da Fazenda via Arquivo Excel</ModalHeader>
                                        <ModalBody>
                                            <p>
                                                <span>Arquivo em formato Excel (.xls, .xlsx, ou .csv) contendo as informações da Produção de Leite.</span><br />
                                                <span>Arquivo de modelo: <a href="./modelo_importacao_producao.xlsx" target="_blank" download>Modelo de Importação de Produções</a></span>
                                            </p>
                                            <Row>
                                                <Col>
                                                    <FormGroup>
                                                        <Label className="left" for="arquivo">Excel</Label>
                                                        <Input
                                                            id="arquivo"
                                                            label="Arquivo"
                                                            onChange={e => setFile(e)}
                                                            type="file"
                                                        />
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                        </ModalBody>
                                        <ModalFooter>
                                            <Button onClick={handleCloseProducao} color="secondary">Cancelar</Button>
                                            <Button onClick={(event) => handleImportProducao(event)} color="primary">Importar Produção</Button>
                                        </ModalFooter>
                                    </Modal>

                                    <Modal isOpen={openPartos} onClose={handleClosePartos} aria-labelledby="form-dialog-title">
                                        <ModalHeader id="form-dialog-title">Importação de Partos da Fazenda via Arquivo Excel</ModalHeader>
                                        <ModalBody>
                                            <p>
                                                <span>Arquivo em formato Excel (.xls, .xlsx, ou .csv) contendo as informações dos Partos.</span><br />
                                                <span>Arquivo de modelo: <a href="./modelo_importacao_partos.xlsx" target="_blank" download>Modelo de Importação de Partos</a></span>
                                            </p>
                                            <Row>
                                                <Col>
                                                    <FormGroup>
                                                        <Label className="left" for="arquivo">Excel</Label>
                                                        <Input
                                                            id="arquivo"
                                                            label="Arquivo"
                                                            onChange={e => setFile(e)}
                                                            type="file"
                                                        />
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                        </ModalBody>
                                        <ModalFooter>
                                            <Button onClick={handleClosePartos} color="secondary">Cancelar</Button>
                                            <Button onClick={(event) => handleImportPartos(event)} color="primary">Importar Partos</Button>
                                        </ModalFooter>
                                    </Modal>

                                    <Modal isOpen={openInseminacoes} onClose={handleCloseInseminacoes} aria-labelledby="form-dialog-title">
                                        <ModalHeader id="form-dialog-title">Importação de Inseminações da Fazenda via Arquivo Excel</ModalHeader>
                                        <ModalBody>
                                            <p>
                                                <span>Arquivo em formato Excel (.xls, .xlsx, ou .csv) contendo as informações das Inseminações.</span><br />
                                                <span>Arquivo de modelo: <a href="./modelo_importacao_inseminacoes.xlsx" target="_blank" download>Modelo de Importação de Inseminações</a></span>
                                            </p>
                                            <Row>
                                                <Col>
                                                    <FormGroup>
                                                        <Input
                                                            id="mesclar"
                                                            label="Mesclar"
                                                            type="checkbox"
                                                            onChange={e => setMesclar(e.target.checked)}
                                                            style={{ justifyContent: 'left', alignItems: 'left', marginLeft: '3px', marginBottom: '15px' }}
                                                        />
                                                        <Label className="left" style={{ marginLeft: '20px' }} for="mesclar">Mesclar: Deixar que o sistema mescle as datas caso exista alguma dentro da semana já criada</Label>
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <FormGroup>
                                                        <Label className="left" for="arquivo">Excel</Label>
                                                        <Input
                                                            id="arquivo"
                                                            label="Arquivo"
                                                            onChange={e => setFile(e)}
                                                            type="file"
                                                        />
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                        </ModalBody>
                                        <ModalFooter>
                                            <Button onClick={handleCloseInseminacoes} color="secondary">Cancelar</Button>
                                            <Button onClick={(event) => handleImportInseminacoes(event)} color="primary">Importar Inseminações</Button>
                                        </ModalFooter>
                                    </Modal>

                                    <Modal isOpen={openCopiarFazenda} onClose={handleCloseCopiarFazenda} aria-labelledby="form-dialog-title">
                                        <ModalHeader id="form-dialog-title">Copiar fazenda</ModalHeader>
                                        <ModalBody>
                                            <Row>
                                                <Col>
                                                    <FormGroup>
                                                        <Label className="left" for="copiarFazenda">Selecione a fazenda da qual você deseja replicar os dados: </Label>
                                                        <Select
                                                            classNamePrefix="select"
                                                            value={renderOptionsFazendas().filter(function (option) {
                                                                return option.value === (fazendaSelecionada || '');
                                                            })}
                                                            onChange={handleSelectChange('id_fazenda')}
                                                            isSearchable
                                                            placeholder="Selecione..."
                                                            id="id_fazenda"
                                                            name="id_fazenda"
                                                            options={renderOptionsFazendas()}
                                                        />
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                        </ModalBody>
                                        <ModalFooter>
                                            <Button onClick={handleCloseCopiarFazenda} color="secondary">Cancelar</Button>
                                            <Button onClick={handleCopiarFazenda} color="primary">Copiar Fazenda</Button>
                                        </ModalFooter>
                                    </Modal>

                                    <Modal isOpen={openRecuperarAnimal} onClose={handleCloseRecuperarAnimal} aria-labelledby="form-dialog-title">
                                        <ModalHeader id="form-dialog-title">Recuperação de animal excluído</ModalHeader>
                                        <ModalBody>
                                            <Row>
                                                <Col>
                                                    <FormGroup>
                                                        <Label className="left" for="animalRecuperar">Selecione o animal que deseja recuperar: </Label>
                                                        <Select
                                                            classNamePrefix="select"
                                                            value={renderOptionsAnimalRecuperar().filter(function (option) {
                                                                return option.value === (props.animal.id || '0');
                                                            })}
                                                            onChange={handleSelectChange('id')}
                                                            isSearchable
                                                            placeholder="Selecione..."
                                                            id="id"
                                                            name="id"
                                                            options={renderOptionsAnimalRecuperar()}
                                                        />
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                        </ModalBody>
                                        <ModalFooter>
                                            <Button onClick={handleCloseRecuperarAnimal} color="secondary">Cancelar</Button>
                                            <Button onClick={handleRecuperarAnimal} color="primary">Recuperar animal</Button>
                                        </ModalFooter>
                                    </Modal>

                                    <Modal size="lg" isOpen={openCadastroCertificados} onClose={handleCloseCadastroCertificados} aria-labelledby="form-dialog-title">
                                        <ModalHeader id="form-dialog-title">{editCertificado ? 'Editar certificado' : 'Cadastrar certificado'}</ModalHeader>
                                        <ModalBody>
                                            <Row>
                                                <Col md={7} lg={7}>
                                                    <FormGroup className="form-group-custom">
                                                        <Label for="nome">Nome</Label>
                                                        <Input
                                                            id="nome"
                                                            label="nome"
                                                            className="form-control"
                                                            value={props.fazendaCertificado.nome || ''}
                                                            onChange={handleChangeCertificado('nome')}
                                                        />
                                                    </FormGroup>
                                                </Col>
                                                <Col md={4} lg={4}>
                                                    <FormGroup className="form-group-custom">
                                                        <Label for="pessoaCertificado">Pessoa *</Label>
                                                        <div className="radio-group-container">
                                                            <label className="radio-option">
                                                                <Input
                                                                    type="radio"
                                                                    name="pessoaCertificado"
                                                                    checked={pessoaFisicaCertificado}
                                                                    onChange={handleChangeRadioCertificado('fisica')}
                                                                />
                                                                <span>Física</span>
                                                            </label>
                                                            <label className="radio-option">
                                                                <Input
                                                                    type="radio"
                                                                    name="pessoaCertificado"
                                                                    checked={!pessoaFisicaCertificado}
                                                                    onChange={handleChangeRadioCertificado('juridica')}
                                                                />
                                                                <span>Jurídica</span>
                                                            </label>
                                                        </div>
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={6} lg={6}>
                                                    <FormGroup className="form-group-custom">
                                                        <Label for="chave">{pessoaFisicaCertificado == true ? 'CPF *' : 'CNPJ *'}</Label>
                                                        <Input
                                                            id="chave"
                                                            label="chave"
                                                            className="form-control"
                                                            value={props.fazendaCertificado.chave || ''}
                                                            onChange={handleChangeCertificado('chave')}
                                                            mask={pessoaFisicaCertificado == true ? '999.999.999-99' : '99.999.999/9999-99'}
                                                            maskChar=" "
                                                            tag={InputMask}
                                                        />
                                                    </FormGroup>
                                                </Col>
                                                <Col md={6} lg={6}>
                                                    <FormGroup className="form-group-custom">
                                                        <Label for="data_validade">Data de Validade *</Label>
                                                        <Input
                                                            id="data_validade"
                                                            label="Data de Validade *"
                                                            className="form-control"
                                                            type="date"
                                                            InputLabelProps={{
                                                                shrink: true,
                                                            }}
                                                            value={props.fazendaCertificado.data_validade?.substring(0, 10) || ''}
                                                            onChange={handleChangeCertificado('data_validade')}
                                                        />
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={6} lg={6}>
                                                    <FormGroup className="form-group-custom">
                                                        <Label for="senha">Senha</Label>
                                                        <div className="position-relative">
                                                            <Input
                                                                id="senha"
                                                                label="senha"
                                                                className="form-control pr-5"
                                                                type={showPassword ? "text" : "password"}
                                                                value={props.fazendaCertificado.senha || ''}
                                                                onChange={handleChangeCertificado('senha')}
                                                            />
                                                            <button
                                                                type="button"
                                                                className="btn btn-link position-absolute"
                                                                style={{ right: '10px', top: '50%', transform: 'translateY(-50%)', zIndex: 10, color: '#6c757d', padding: 0, border: 'none', background: 'transparent' }}
                                                                onClick={() => setShowPassword(!showPassword)}
                                                            >
                                                                <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                                                            </button>
                                                        </div>
                                                    </FormGroup>
                                                </Col>
                                                <Col md={6} lg={6}>
                                                    <FormGroup className="form-group-custom">
                                                        <Label for="caminho_certificado">Caminho do certificado</Label>
                                                        <Input
                                                            id="caminho_certificado"
                                                            label="caminho_certificado"
                                                            className="form-control"
                                                            value={props.fazendaCertificado.caminho_certificado || ''}
                                                            onChange={handleChangeCertificado('caminho_certificado')}
                                                        />
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                        </ModalBody>
                                        <ModalFooter>
                                            <Button onClick={handleCloseCadastroCertificados} color="secondary">Cancelar</Button>
                                            <Button onClick={handleSubmitCertificado} color="primary">{editCertificado ? 'Editar' : 'Cadastrar'}</Button>
                                        </ModalFooter>
                                    </Modal>

                                    <Modal isOpen={openCadastroIntegracoes} onClose={handleCloseCadastroIntegracoes} aria-labelledby="form-dialog-title">
                                        <ModalHeader id="form-dialog-title">{editIntegracao ? 'Editar integração' : 'Cadastrar integração'}</ModalHeader>
                                        <ModalBody>
                                            <Row className="mt-1">
                                                <Col md={8} lg={8} >
                                                    <FormGroup className="form-group-custom">
                                                        <Label for="chave">Código de integração *</Label>
                                                        <Input
                                                            id="chave"
                                                            label="chave"
                                                            className="form-control"
                                                            value={props.fazendaIntegracao.codigo_integracao || ''}
                                                            onChange={handleChangeIntegracao('codigo_integracao')}
                                                            maskChar=" "
                                                            tag={InputMask}
                                                        />
                                                    </FormGroup>
                                                    <FormGroup className="form-group-custom">
                                                        <Label for="tipo_integracao">Tipo de integração *</Label>
                                                        <Select
                                                            classNamePrefix="select"
                                                            placeholder="Selecione..."
                                                            className="basic-single"
                                                            value={renderOptionsTipoIntegracao().filter(function (option) {
                                                                return option.value == props.fazendaIntegracao.tipo
                                                            })}
                                                            onChange={handleSelectChangeIntegracao('tipo')}
                                                            isSearchable
                                                            id="tipo_integracao"
                                                            name="tipo_integracao"
                                                            options={renderOptionsTipoIntegracao()}
                                                        />
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                        </ModalBody>
                                        <ModalFooter>
                                            <Button onClick={handleCloseCadastroIntegracoes} color="secondary">Cancelar</Button>
                                            <Button onClick={handleSubmitIntegracao} color="primary" style={{ background: 'linear-gradient(45deg, #398434, #49a942)', border: 'none' }}>{editIntegracao ? 'Editar' : 'Cadastrar'}</Button>
                                        </ModalFooter>
                                    </Modal>
                                </Form>
                            </TabPane>
                            <TabPane tabId="2">
                                <Row>
                                    <Col md={8}>
                                        <h5 className="left">Lista de Certificados</h5>
                                    </Col>
                                    {authActions.isGestor() && params.id ? (
                                        <Col md={4} className="d-flex flex-row-reverse">
                                            <Button id="btnNovo" color="primary" className="btn-sm" component='a' onClick={() => handleClickOpenCadastroCertificados(0)} href="" style={{ background: 'linear-gradient(45deg, #398434, #49a942)', border: 'none' }}>Novo <FontAwesomeIcon icon={faPlusCircle} /></Button>
                                            <UncontrolledTooltip placement="bottom" target="btnNovo">
                                                Adiciona um novo certificado
                                            </UncontrolledTooltip>
                                        </Col>
                                    ) : (<span></span>)}
                                </Row>
                                <Row>
                                    <Col md={4} >
                                        <Input
                                            id="term"
                                            label="term"
                                            placeholder="Filtro"
                                            value={term}
                                            onChange={handleChangeTerm('term')}
                                        />
                                    </Col>
                                </Row>
                                <br />
                                <DataTable
                                    title=""
                                    columns={columns}
                                    pagination={true}
                                    striped={true}
                                    noDataComponent="Sem registros para mostrar"
                                    paginationComponentOptions={{ rowsPerPageText: 'Registros por página:', rangeSeparatorText: 'de', noRowsPerPage: false, selectAllRowsItem: false, selectAllRowsItemText: 'Tudo' }}
                                    data={fazendaCertificado?.filter((item) => {
                                        const chaveFormatada = item.chave.replace(/\D/g, '');
                                        const tipoPessoa = chaveFormatada.length === 14 ? 'juridica' : 'fisica';
                                        const nomeSemAcentos = item.nome
                                            ? item.nome.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
                                            : '';
                                        // Normaliza o termo para remoção de acentos
                                        const termNormalized = term.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();

                                        if (term === "") {
                                            return item;
                                        } else if (chaveFormatada.toLowerCase().includes(termNormalized)) {
                                            return item;
                                        } else if (nomeSemAcentos.includes(termNormalized)) {
                                            return item;
                                        } else if (['juridica', 'fisica'].includes(tipoPessoa) && tipoPessoa.includes(termNormalized)) {
                                            return item;
                                        }
                                    })}
                                />
                            </TabPane>
                            <TabPane tabId="3">
                                <Row>
                                    <Col md={8}>
                                        <h5 className="left">Lista de Integrações</h5>
                                    </Col>
                                    {authActions.isGestor() && params.id ? (
                                        <Col md={4} className="d-flex flex-row-reverse">
                                            <Button id="btnNova" color="primary" className="btn-sm" component='a' onClick={() => handleClickOpenCadastroIntegracoes(0)} href="">Nova&nbsp;<FontAwesomeIcon icon={faPlusCircle} /></Button>
                                            <UncontrolledTooltip placement="bottom" target="btnNova">
                                                Adiciona uma nova integração
                                            </UncontrolledTooltip>
                                        </Col>
                                    ) : (<span></span>)}
                                </Row>
                                <Row>
                                    <Col md={4} >
                                        <Input
                                            id="term"
                                            label="term"
                                            placeholder="Filtro"
                                            value={term}
                                            onChange={handleChangeTerm('term')}
                                        />
                                    </Col>
                                </Row>
                                <br />
                                <DataTable
                                    title=""
                                    columns={columnsIntegracao}
                                    pagination={true}
                                    striped={true}
                                    noDataComponent="Sem registros para mostrar"
                                    paginationComponentOptions={{ rowsPerPageText: 'Registros por página:', rangeSeparatorText: 'de', noRowsPerPage: false, selectAllRowsItem: false, selectAllRowsItemText: 'Tudo' }}
                                    data={fazendaIntegracao && fazendaIntegracao?.filter((item) => {
                                        if (term === "") {
                                            return item;
                                        } else if (item.codigo_integracao.toLowerCase().includes(term)) {
                                            return item;
                                        }
                                    })}
                                />
                            </TabPane>
                        </TabContent>
                    </CardBody>
                </Card>
            </Container >
            <ModalLog toggle={toggle} modal={modal} log={log} />

            
        </div >
    );
}

const mapStateToProps = (state) => {
    return state;
}

const connectedFazendaEditPage = withRouter(connect(mapStateToProps, null, null, {
    pure: false
})(FazendaEdit));

export { connectedFazendaEditPage as FazendaEdit };
